import Cookies from "universal-cookie";
import { createReducer } from "reduxsauce";
import _ from "lodash";
import Types from "../actions/Types";
// import I18n from '../i18n/I18n';
import Helper from "../helper/Helper";
import currencies from "./data/currencies.json"; // TODO: Remove before production, currencies loaded server side
import countriesEN from "./data/countries_en.json"; // TODO: Remove before production, currencies loaded server side
import countriesAR from "./data/countries_ar.json"; // TODO: Remove before production, currencies loaded server side

const cookies = new Cookies("");
const currency = currencies.AED;
const countries = cookies.get("lang") === "ar" ? countriesAR : countriesEN;
const country = countries.AE;
/* Generic error message */
const genericError = "Something went wrong";

export const INITIAL_STATE = {
  errorMessage: false,
  currency: currency,
  country: country,
  isLoading: false,
  isGuest: true,
  isTnCLoading: false,
  isSellerLoading: false,
  tnc: "",
  isWareHousesLoading: false,
  wareHouses: null,
  users: null,
  isUsersLoading: false,
  isNotificationLoading: false,
  notificationPreference: null,
  isPreferenceLoading: false,
  isPostPreferenceloading: false,
  fbnSetting: null,
  isFbnSettingsLoading: false
};

function getUser(state = INITIAL_STATE) {
  return { ...state, data: null, errorMessage: false, isLoading: true };
}

function getUserSuccess(state = INITIAL_STATE, action) {
  Helper.setFSUser(action.user);
  return {
    ...state,
    user: action.user,
    isGuest: false,
    isLoading: false,
    isUserLoaded: true
  };
}

function getUserFailure(state = INITIAL_STATE) {
  return {
    ...state,
    user: null,
    isGuest: true,
    isLoading: false,
    isUserLoaded: true
  };
}

/************************************************
GETTING NOTIFICATION PREFERENCE
*************************************************/

function getNotificationPreference(state = INITIAL_STATE) {
  return { ...state, errorMessage: false, isPreferenceLoading: true };
}

function getNotificationPreferenceSuccess(state = INITIAL_STATE, action) {
  return {
    ...state,
    isPreferenceLoading: false,
    notificationPreference: action.preference
  };
}

function getNotificationPreferenceFailure(state = INITIAL_STATE) {
  return {
    ...state,
    isPreferenceLoading: false,
    notificationPreference: null
  };
}

/************************************************
POSTING NOTIFICATION PREFERENCE
*************************************************/

function postPreference(state = INITIAL_STATE) {
  return {
    ...state,
    //isLoading: true,
    isPostPreferenceloading: true,
    successMessage: null,
    errorMessage: null
  };
}

function postPreferenceSuccess(state = INITIAL_STATE, action) {
  return {
    ...state,
    pref: action.pref,
    isPostPreferenceloading: false
  };
}

function postPreferenceFailure(state = INITIAL_STATE, action) {
  return {
    ...state,
    errorMessage: (action && action.error) || genericError,
    //isLoading: false
    isPostPreferenceloading: false
  };
}

/************************************************
 *************************************************/

function getSeller(state = INITIAL_STATE) {
  return { ...state, data: null, errorMessage: false, isSellerLoading: true };
}

function getSellerSuccess(state = INITIAL_STATE, action) {
  const seller = action.seller;
  const match =
    action &&
    action.partnerCountries &&
    !_.isEmpty(action.partnerCountries) &&
    action.partnerCountries.find(
      eachCountry =>
        eachCountry &&
        eachCountry.country_code &&
        eachCountry.country_code.toLowerCase() === Helper.getCountry()
    );
  if (action && action.partnerCountries && action.partnerCountries.length > 0) {
    if (!match) {
      Helper.toggleCountry(
        action && action.partnerCountries
          ? action.partnerCountries[0].country_code.toLowerCase()
          : "ae"
      );
      seller.selected_currency = action.partnerCountries[0].currency;
      seller.is_allow_price_edit =
        action.partnerCountries[0].is_allow_price_edit;
    } else {
      seller.selected_currency = match.currency;
      seller.is_allow_price_edit = match.is_allow_price_edit;
    }
  }
  return {
    ...state,
    seller,
    isNoonUser: action.isNoonUser,
    partnerCountries: action.partnerCountries,
    partnerMenu: action.partnerMenu,
    isSellerLoading: false,
    isUserLoaded: true
  };
}

function getSellerFailure(state = INITIAL_STATE) {
  return {
    ...state,
    seller: null,
    isSellerLoading: false,
    isUserLoaded: true
  };
}

function logout(state = INITIAL_STATE) {
  return {
    ...state,
    data: null,
    errorMessage: false,
    isLoading: true,
    isSellerLoading: true
  };
}

function logoutSuccess(state = INITIAL_STATE) {
  return {
    ...state,
    token: "not-used",
    user: null,
    seller: null,
    isGuest: true,
    isLoading: false,
    isSellerLoading: false
  };
}

function logoutFailure(state = INITIAL_STATE) {
  return { ...state, isLoading: false, isSellerLoading: false };
}

function acceptTerms(state = INITIAL_STATE) {
  return { ...state, data: null, errorMessage: false, isSellerLoading: true };
}

function acceptTermsSuccess(state = INITIAL_STATE, action) {
  // Helper.setFSUser(action.user);
  return {
    ...state,
    seller: action.seller,
    isSellerLoading: false,
    isUserLoaded: true
  };
}

function acceptTermsFailure(state = INITIAL_STATE) {
  return {
    ...state,
    seller: null,
    isSellerLoading: false,
    isUserLoaded: true
  };
}

/* Get TNC */
export const getTnC = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isTnCLoading: true
  };
};

export const getTnCSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    tnc: action.tnc,
    isTnCLoading: false
  };
};

export const getTnCFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isTnCLoading: false,
  errorMessage: action.errorMessage
});

/* Get WareHouse details */
export const getWareHouses = (state: Object = INITIAL_STATE, action) => {
  return {
    ...state,
    isWareHousesLoading:
      action.query && action.query.indexOf("id_partner_warehouse") === -1,
    isFbn: action.query && action.query.indexOf("is_fbn") !== -1,
    byWarehouse:
      action.query && action.query.indexOf("id_partner_warehouse") !== -1,
    isOwned: action.query && action.query.indexOf("is_owned") !== -1
  };
};

export const getWareHousesSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const val = {
    ...state,
    isWareHousesLoading: false,
    isFbn: false,
    byWarehouse: false,
    isOwned: false
  };
  if (state.byWarehouse) {
    val.warehousesbyWh = action.warehouses;
  } else if (state.isFbn) {
    val.fbnWarehouses = action.warehouses;
  } else if (state.isOwned) {
    val.ownedWarehouses = action.warehouses;
  } else {
    val.wareHouses = action.warehouses;
  }
  return val;
};

export const getWareHousesFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isWareHousesLoading: false,
  errorMessage: action.error
});

/* Get Vat details */
export const getVatInfo = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isWareHousesLoading: true
  };
};

export const getVatInfoSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    vat: action.vat,
    isWareHousesLoading: false
  };
};

export const getVatInfoFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isWareHousesLoading: false,
  errorMessage: action.error
});

/* Get users List*/
export const getUsersList = (state: Object = INITIAL_STATE) => ({
  ...state,
  isUsersLoading: true
});

export const getUsersListSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  users: action.users,
  isUsersLoading: false
});

export const getUsersListFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isUsersLoading: false,
  errorMessage: action.error
});

/* Get users List*/
export const getOfferCount = (state: Object = INITIAL_STATE) => ({
  ...state,
  isOfferCounting: true
});

export const getOfferCountSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  offerCount: action.offerCount,
  isOfferCounting: false
});

export const getOfferCountFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isOfferCounting: false,
  errorMessage: action.error
});

/* SYNC INVENTORY*/
export const syncInventory = (state = INITIAL_STATE) => ({
  ...state
});

export const syncInventorySuccess = (state = INITIAL_STATE) => ({
  ...state
});

export const syncInventoryFailure = (state = INITIAL_STATE) => ({
  ...state
});

/**** NOTIFICATIONS **/

function getNotification(state = INITIAL_STATE, action) {
  return {
    ...state,
    isNotificationLoading: true,
    isListing: action.isList
  };
}

function getNotificationSuccess(state = INITIAL_STATE, action) {
  const val = {
    ...state,
    isNotificationLoading: false,
    isListing: false
  };
  if (!state.isListing) {
    val.notification = action.notification;
  } else {
    val.listNotification = action.notification;
  }
  return val;
}

function getNotificationFailure(state = INITIAL_STATE) {
  return {
    ...state,
    notification: null,
    isNotificationLoading: false,
    isListing: false
  };
}

/**** READ NOTIFICATIONS **/

function readNotification(state = INITIAL_STATE) {
  return { ...state, isReading: true };
}

function readNotificationSuccess(state = INITIAL_STATE, action) {
  return {
    ...state,
    isReading: false
  };
}

function readNotificationFailure(state = INITIAL_STATE) {
  return {
    ...state,
    isReading: false
  };
}

/**** GET FBN Settings **/

function getFbnSettings(state = INITIAL_STATE) {
  return { ...state, isFbnSettingsLoading: true };
}

function getFbnSettingsSuccess(state = INITIAL_STATE, action) {
  return {
    ...state,
    isFbnSettingsLoading: false,
    fbnSetting: action.fbnSetting
  };
}

function getFbnSettingsFailure(state = INITIAL_STATE) {
  return {
    ...state,
    isFbnSettingsLoading: false,
    fbnSetting: null
  };
}

/************************************************
POSTING FBN SETTINGS
*************************************************/

function changeFbnSettings(state = INITIAL_STATE) {
  return {
    ...state,
    //isFbnSettingsLoading: true,
    successMessage: null,
    errorMessage: null
  };
}

function changeFbnSettingsSuccess(state = INITIAL_STATE, action) {
  return {
    ...state,
    fbnSetting: action.fbnSetting
    //isFbnSettingsLoading: false
  };
}

function changeFbnSettingsFailure(state = INITIAL_STATE, action) {
  return {
    ...state,
    errorMessage: (action && action.error) || genericError
    //isFbnSettingsLoading: false
  };
}
const ACTION_HANDLERS = {
  [Types.GET_USER]: getUser,
  [Types.GET_USER_SUCCESS]: getUserSuccess,
  [Types.GET_USER_FAILURE]: getUserFailure,
  [Types.GET_SELLER]: getSeller,
  [Types.GET_SELLER_SUCCESS]: getSellerSuccess,
  [Types.GET_SELLER_FAILURE]: getSellerFailure,
  [Types.LOGOUT]: logout,
  [Types.LOGOUT_SUCCESS]: logoutSuccess,
  [Types.LOGOUT_FAILURE]: logoutFailure,
  [Types.ACCEPT_TERMS]: acceptTerms,
  [Types.ACCEPT_TERMS_SUCCESS]: acceptTermsSuccess,
  [Types.ACCEPT_TERMS_FAILURE]: acceptTermsFailure,
  [Types.GET_TNC]: getTnC,
  [Types.GET_TNC_SUCCESS]: getTnCSuccess,
  [Types.GET_TNC_FAILURE]: getTnCFailure,
  [Types.GET_WAREHOUSES]: getWareHouses,
  [Types.GET_WAREHOUSES_SUCCESS]: getWareHousesSuccess,
  [Types.GET_WAREHOUSES_FAILURE]: getWareHousesFailure,
  [Types.GET_USERS_LIST]: getUsersList,
  [Types.GET_USERS_LIST_SUCCESS]: getUsersListSuccess,
  [Types.GET_USERS_LIST_FAILURE]: getUsersListFailure,
  [Types.GET_VAT_INFO]: getVatInfo,
  [Types.GET_VAT_INFO_SUCCESS]: getVatInfoSuccess,
  [Types.GET_VAT_INFO_FAILURE]: getVatInfoFailure,

  [Types.GET_OFFER_COUNT]: getOfferCount,
  [Types.GET_OFFER_COUNT_SUCCESS]: getOfferCountSuccess,
  [Types.GET_OFFER_COUNT_FAILURE]: getOfferCountFailure,

  [Types.SYNC_INVENTORY]: syncInventory,
  [Types.SYNC_INVENTORY_SUCCESS]: syncInventorySuccess,
  [Types.SYNC_INVENTORY_FAILURE]: syncInventoryFailure,

  [Types.GET_NOTIFICATION]: getNotification,
  [Types.GET_NOTIFICATION_SUCCESS]: getNotificationSuccess,
  [Types.GET_NOTIFICATION_FAILURE]: getNotificationFailure,
  [Types.READ_NOTIFICATION]: readNotification,
  [Types.READ_NOTIFICATION_SUCCESS]: readNotificationSuccess,
  [Types.READ_NOTIFICATION_FAILURE]: readNotificationFailure,

  [Types.GET_NOTIFICATION_PREFERENCE]: getNotificationPreference,
  [Types.GET_NOTIFICATION_PREFERENCE_SUCCESS]: getNotificationPreferenceSuccess,
  [Types.GET_NOTIFICATION_PREFERENCE_FAILURE]: getNotificationPreferenceFailure,

  [Types.POST_PREFERENCE]: postPreference,
  [Types.POST_PREFERENCE_SUCCESS]: postPreferenceSuccess,
  [Types.POST_PREFERENCE_FAILURE]: postPreferenceFailure,

  [Types.GET_FBN_SETTINGS]: getFbnSettings,
  [Types.GET_FBN_SETTINGS_SUCCESS]: getFbnSettingsSuccess,
  [Types.GET_FBN_SETTINGS_FAILURE]: getFbnSettingsFailure,

  [Types.CHANGE_FBN_SETTINGS]: changeFbnSettings,
  [Types.CHANGE_FBN_SETTINGS_SUCCESS]: changeFbnSettingsSuccess,
  [Types.CHANGE_FBN_SETTINGS_FAILURE]: changeFbnSettingsFailure
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/SessionReducer.js